export const feedbackFilterables = [
  'status',
  'recipient_name',
  'provider_name',
  'requester_name'
];
